import { render, staticRenderFns } from "./FI.vue?vue&type=template&id=8fb748a4"
import script from "./FI.vue?vue&type=script&lang=js"
export * from "./FI.vue?vue&type=script&lang=js"
import style0 from "./FI.vue?vue&type=style&index=0&id=8fb748a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports